export class MatterType {
  id: number;
  name: string;
  graph_group: number;
  graph_label: string;
  is_flat_fee: boolean = true;
  is_hourly: boolean = true;
  is_no_charge: boolean = false;
  is_percentage: boolean = false;
  invoice_by_default: boolean = true;
  regarding: string;
  we_will_do: string;
  primary_activity_id: number;
  intranet_id: number;
  consult_fee: number;
  retainer: number;
}
